/**
 * @file Home.page.tsx
 * @description The main landing page. Orchestrates the Hero, Audience Stacks, and metadata.
 */

import { shuttle1 } from "@/assets";
import { scene2 } from "@/assets/videos";
import {
  BookingStepsSection,
  CallToAction,
  FeaturedSection,
  HeroSection,
  SeoHelmet,
  TestimonialsSection,
} from "@/components";
import { StackedSection } from "@/components/sections/stackedSection.component";
import { NAV_LINKS, PATHS } from "@/config/paths.config";
import { audienceData } from "@/data/audience"; // Import your audience data

export const HomePage = () => {
  return (
    <>
      <SeoHelmet
        pageType="default"
        title="Sir Bastian's Shuttle Service | Arrive in Style"
      />

      <main className="flex min-h-screen flex-col">
        {/* HERO SECTION */}
        <HeroSection
          title="Arrive in Style"
          subtitle="Depart with Ease"
          paragraph="Experience the best of Cape Town with our premium airport transfers, curated private tours, and reliable student shuttle services."
          buttonText="Start Exploring"
          buttonLink={PATHS.EXPERIENCES}
          videoSrc={scene2}
          playbackRate={0.8}
        />

        <StackedSection />

        <FeaturedSection />

        <BookingStepsSection />

        <TestimonialsSection />

        {/* CTA Section */}
        <CallToAction
          title="Your Journey, Our Commitment"
          description="Punctuality, safety, and comfort are at the core of our experience. From airport transfers to student shuttles, trust Sir Bastian's for a professional and reliable ride, every time."
          primaryAction={{
            text: "Book Your Ride",
            href: NAV_LINKS.experiences.path,
          }}
          secondaryAction={{
            text: "Our Activities",
            href: NAV_LINKS.experiences.path,
          }}
          backgroundImage={{
            src: shuttle1,
            alt: "Sunrise over a road leading into Cape Town with Table Mountain in the distance",
          }}
          className="mt-16"
        />
      </main>
    </>
  );
};
